export const defaultFormLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 14 },
};

export const defaultFormTailLayout = {
  wrapperCol: { offset: 8, span: 14 },
};
